import{jsx as r}from"react/jsx-runtime";import{createContext as a,useContext as s}from"react";const t=a({}),p=()=>s(t),x=({value:e={},children:o})=>r(t.Provider,{value:e,children:o});export{x as DataDisplayProvider,p as useDataDisplay};
